import { render, staticRenderFns } from "./Iconify.vue?vue&type=template&id=4acc6196&"
import script from "./Iconify.vue?vue&type=script&lang=js&"
export * from "./Iconify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports